/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ViolationBase {
    getFixupPrototypeFunction() { return ViolationBase.fixupPrototype; }

    static newInstance(model: Partial<ViolationBase>): ViolationBase {
        let obj = Object.assign(new ViolationBase(), model);
        ViolationBase.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ViolationBase>): ViolationBase {
        if (!model) return null;
        return ViolationBase.newInstance(<ViolationBase> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ViolationBase) {
        if (!obj) return;

        models.ViolationBase.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ViolationBase): boolean {
        Object.setPrototypeOf(obj, ViolationBase.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Rule ID.
     */
    scanner_rule_id: string;

    /**
     * Identifier Name for the resource for which the scanning is being done.
     */
    resource_identifier: string;

    /**
     * Name of the File against which the violation has been generated.
     */
    file_name: string;

}
